module.exports = __webpack_public_path__ + "assets/img/102001.c1350ac4.svg";